module.exports = __webpack_public_path__ + "static/Mackenzie-8a10cdff0b068228923ccd11a9e54e50.png";